<template>
    <tbody>
        <tr>
            <td>
                <pml-select v-model="record.product_id" :options="products"></pml-select>
                <span class="error" v-if="errors['product_id']">{{ errors['product_id'][0] }}</span>
            </td>
            <td class="t_center">
                <div class="input-group">
                    <pml-numeric v-model="record.price"></pml-numeric>
                    <span class="input-group-addon">{{ supplier.currency_id | pmlCurrencyById('symbol') }}</span>
                </div>
                <span class="error" v-if="errors['price']">{{ errors['price'][0] }}</span>
            </td>
            <td class="t_center">
                <div class="input-group">
                    <pml-numeric v-model="record.kickback"></pml-numeric>
                    <span class="input-group-addon">%</span>
                </div>
                <span class="error" v-if="errors['kickback']">{{ errors['kickback'][0] }}</span>
            </td>
            <td class="t_center">
                <div class="input-group">
                    <pml-numeric v-model="record.discount_limit"></pml-numeric>
                    <span class="input-group-addon">%</span>
                </div>
                <span class="error" v-if="errors['discount_limit']">{{ errors['discount_limit'][0] }}</span>
            </td>
            <td class="t_center">
                <pml-select v-model="record.unit" :options="units"></pml-select>
                <span class="error" v-if="errors['unit']">{{ errors['unit'][0] }}</span>
            </td>
            <td class="t_center" rowspan="2">
                <button class="btn btn-default btn-block btn-xs" v-pml-block="isSaving" @click.prevent="save()"><i class="fa-fw fa fa-check m-r-5"></i> {{ $t('save') }}</button>
                <button class="btn btn-white btn-block btn-xs" @click.prevent="cancel()"><i class="fa fa-times m-r-5"></i>{{ $t('cancel') }}</button>
            </td>
        </tr>
        <tr>
            <td colspan="5">
                <div class="row">
                    <div class="col-xs-12 col-sm-7">
                        <strong class="show m-b-5">{{ $t('internal_annotation') }}</strong>
                        <input class="form-control" type="text" v-model="record.annotations">
                        <span class="error" v-if="errors['annotations']">{{ errors['annotations'][0] }}</span>
                    </div>
                    <div class="col-xs-12 col-sm-5">
                        <div class="show m-t-30 m-b-20">
                            <pml-checkbox v-model="record.allow_edit" :label="$t('allow_edit_price_during_quotation')"></pml-checkbox>
                        </div>
                    </div>
                </div>
                <strong class="show m-b-5">{{ $t('product_description_in_quotation') }}</strong>
                <textarea class="form-control" type="text" v-model="record.description" v-pml-autosize></textarea>
                <span class="error" v-if="errors['description']">{{ errors['description'][0] }}</span>
            </td>
        </tr>
    </tbody>
</template>

<script>
    import { createProduct } from 'services/suppliers'
    import { mapGetters } from 'vuex'

    export default {
        name: 'SupplierProductForm',
        props: [ 'supplier' ],
        data () {
            return {
                isSaving: false,
                record: {
                    product_id: null,
                    unit: null,
                    price: null,
                    kickback: null,
                    discount_limit: null,
                    allow_edit: false
                },
                errors: []
            }
        },
        computed: {
            ...mapGetters({
                'products': 'getProducts',
                'units': 'getProductUnits'
            })
        },
        methods: {
            save () {
                this.isSaving = true

                createProduct(this.supplier.id, this.record)
                    .then(response => {
                        this.$emit('updated', response.data)
                        this.cancel()
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            },
            cancel () {
                this.isSaving = false
                this.record = {
                    product_id: null,
                    unit: null,
                    price: null,
                    kickback: null,
                    discount_limit: null,
                    allow_edit: false
                }
                this.errors = []
                this.$emit('close')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/suppliers/components/products/Form.vue